import PropTypes from 'prop-types';
import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { QueryManager } from '@weezevent/nacre';

import ManageAttendees from './attendees/manage';
import Attendee from './attendees/attendee';
import PageError from './error/pageError';

export default class Attendees extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Switch>
                    <Route
                        exact
                        path={`${this.props.match.path}/`}
                        render={routeProps => (
                            <QueryManager>
                                <ManageAttendees {...routeProps} {...this.props} />
                            </QueryManager>
                        )}
                    />
                    <Route
                        exact
                        path={`${this.props.match.path}/attendee/:attendeeId([0-9]+)`}
                        render={routeProps => <Attendee {...routeProps} event={this.props.event} organization={this.props.organization} />}
                    />
                    <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${this.props.organization.id}/E${this.props.event.id}/dashboard`} />} />
                </Switch>
            </React.Fragment>
        );
    }
}

Attendees.propTypes = {
    event: PropTypes.object,
    match: PropTypes.object,
    organization: PropTypes.object.isRequired
};
